export default __webpack_public_path__ + "static/media/warehouse-2.68fb46db.png";